import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const BlogSection = () => {
  const blogPosts = [
    {
      id: '1',
      category: 'Astroloji',
      title: 'Doğum Haritanız Size Ne Anlatıyor?',
      excerpt: 'Doğum haritanız, kişiliğinizin derinliklerini ve yaşam yolculuğunuzun haritasını ortaya koyar.',
      date: '15 Aralık 2024',
      readTime: '5 dk',
      image: 'https://public.readdy.ai/ai/img_res/854c90ae622d329ad5141913123b5a42.jpg',
    },
    {
      id: '2',
      category: 'Spiritüel Yaşam',
      title: 'İçsel Huzuru Bulmanın 7 Yolu',
      excerpt: 'Günlük hayatın koşuşturmasında içsel dengenizi korumak için pratik spiritüel uygulamalar.',
      date: '10 Aralık 2024',
      readTime: '7 dk',
      image: 'https://readdy.ai/api/search-image?query=serene%20meditation%20scene%20with%20person%20sitting%20in%20peaceful%20lotus%20position%20surrounded%20by%20soft%20golden%20light%20and%20ethereal%20energy%20waves%20on%20calm%20navy%20blue%20background%20spiritual%20wellness%20blog%20image&width=800&height=450&seq=blog002&orientation=landscape',
    },
    {
      id: '3',
      category: 'Enerji & Şifa',
      title: 'Enerji Dengeleme Nedir ve Nasıl Yapılır?',
      excerpt: 'Bedeninizin ve ruhunuzun enerji akışını dengeleyerek sağlıklı bir yaşam sürdürün.',
      date: '5 Aralık 2024',
      readTime: '6 dk',
      image: 'https://readdy.ai/api/search-image?query=healing%20energy%20flow%20visualization%20with%20glowing%20golden%20light%20streams%20and%20chakra%20points%20on%20human%20silhouette%20against%20deep%20navy%20background%20spiritual%20energy%20healing%20concept%20for%20wellness%20blog&width=800&height=450&seq=blog003&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-serif text-5xl font-bold text-primary-dark mb-4">
            Son Yazılar
          </h2>
          <p className="text-text-medium text-lg">
            Astroloji ve Spiritüel Yaşam Üzerine
          </p>
        </motion.div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <motion.article
              key={post.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group"
            >
              <Link to={`/blog/${post.id}`} className="block cursor-pointer">
                {/* Image */}
                <div className="relative overflow-hidden rounded-t-2xl mb-6">
                  <div className="w-full h-64">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                  
                  {/* Category Badge */}
                  <div className="absolute top-4 left-4">
                    <span className="px-4 py-2 bg-gold text-primary-dark text-xs font-bold rounded-full">
                      {post.category}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div>
                  {/* Meta */}
                  <div className="flex items-center space-x-3 text-xs uppercase tracking-wider text-text-light mb-3">
                    <span>{post.date}</span>
                    <span>•</span>
                    <span>{post.readTime} Okuma</span>
                  </div>

                  {/* Title */}
                  <h3 className="font-serif text-2xl font-bold text-primary-dark mb-3 leading-tight group-hover:text-gold transition-colors duration-300">
                    {post.title}
                  </h3>

                  {/* Excerpt */}
                  <p className="text-text-medium leading-relaxed mb-4 line-clamp-2">
                    {post.excerpt}
                  </p>

                  {/* Read More Link */}
                  <div className="flex items-center text-gold text-sm font-medium group-hover:translate-x-1 transition-transform duration-300">
                    <span>Devamını Oku</span>
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>

        {/* View All Button */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-12"
        >
          <Link
            to="/blog"
            className="inline-block px-8 py-4 border-2 border-primary-dark text-primary-dark font-semibold rounded-full hover:bg-primary-dark hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Tüm Yazıları Görüntüle
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default BlogSection;